/* eslint-disable prettier/prettier */

export class MsSql {
    getSelectQuery(tableName: string, limit: number = 0): string {
        let query = `SELECT top ${limit || 1000} * FROM [${tableName}]`;
        return query;
    }

    getInsertQuery(tableName: string, columns: string[], values: string[][]): string {
        let pre = `SET IDENTITY_INSERT [${tableName}] ON; `;
        let queries = values.map((row: string[]) => {
            let rowData = row.map((value) => this.parse(value));
            return `INSERT INTO [${tableName}] ([${columns.join("], [")}]) VALUES (${rowData.join(", ")});`;
        });
        let query = queries.join("\n");
        // var query = `INSERT INTO [${tableName}] ([${columns.join("], [")}]) VALUES (${values.join(", ")})`;
        let post = `SET IDENTITY_INSERT [${tableName}] OFF;`;

        return `${pre} \n\n${query} \n\n${post}`;
    }

    getUpdateQuery(tableName: string, columns: string[], values: string[][], startCol: number, endCol: number): string {
        let queries = values.map((row: string[]) => {
            let rowData = row.slice(startCol, endCol).map((value, index) => `[${columns[startCol + index]}] = ${this.parse(value)}`);
            return `UPDATE [${tableName}] SET ${rowData.join(", ")} where [${columns[0]}] = ${row[0]};`;
        });
        let query = queries.join("\n");

        return query;
    }

    getAddColumnQuery(tableName: string, columns: string[], values: string[][], startCol: number, endCol: number): string {
        let queries = columns.slice(startCol, endCol).map((column) => {
            return `ALTER TABLE [${tableName}] ADD [${column}] ${this.getDataType(column, values)};`;
        });
        let query = queries.join("\n");
        return query;
    }

    getRenameColumnQuery(tableName: string, columns: string[], startCol: number, endCol: number): string {
        let queries = columns.slice(startCol, endCol).map((column) => {
            return `EXEC sp_rename '${tableName}.[${column}]', '${column}New', 'COLUMN';`;
        });
        let query = queries.join("\n");

        return query;
    }

    // Generate query to create a table
    getCreateQuery(tableName: string, columns: string[], values: string[][]): string {
        let queries = columns.map((column) => {
            return `[${column}] ${this.getDataType(column, values)}`;
        });
        let query = `CREATE TABLE [${tableName}] (\n\t${queries.join(", \n\t")}\n);`;

        return query;
    }

    getDataType(columnName: string, values: string[][]): string {
        let dataType = "VARCHAR(250)";
        let maxLength = 0;
        values.forEach((value) => {
            if (value !== null && value.length > maxLength) {
                maxLength = value.length;
            }
        });

        maxLength = Math.max(maxLength, 20);
        if (maxLength > 20) {
            maxLength = Math.max(maxLength, 50);
        }
        if (maxLength > 50) {
            maxLength = Math.max(maxLength, 250);
        }

        let map = {
            Id: "INT IDENTITY(1,1) PRIMARY KEY CLUSTERED NOT NULL",
            GUID: "UNIQUEIDENTIFIER",
            IsActive: "BIT NOT NULL DEFAULT 1",
            CreateDate: "DATETIME NOT NULL DEFAULT GETUTCDATE()",
            UpdateDate: "DATETIME NULL",
            CreatedBy: "INT NOT NULL",
            UpdatedBy: "INT NULL",
            IpAddress: "VARCHAR(50)",
        };

        if (map[columnName]) {
            return map[columnName];
        }

        if (columnName == 'Id') {
            dataType = "INT IDENTITY(1,1) PRIMARY KEY CLUSTERED NOT NULL";
        } else if (columnName.toLowerCase().endsWith("url") || columnName.toLowerCase().endsWith("website")) {
            dataType = "VARCHAR(500)";
        } else if (columnName.toLowerCase().endsWith("name")) {
            dataType = "NVARCHAR(50)";
        } else if (columnName.toLowerCase().endsWith("email")) {
            dataType = "VARCHAR(150)";
        } else if (columnName.endsWith("Id") || columnName.endsWith("Count") || columnName.endsWith("Number") || columnName.includes("Total")) {
            dataType = "INT";
        } else if (columnName.startsWith("Is") || columnName.startsWith("Has")) {
            dataType = "BIT";
        } else if (columnName.endsWith("Date")) {
            dataType = "DATETIME";
        } else if (maxLength > 0) {
            dataType = `NVARCHAR(${maxLength})`;
        }

        return dataType;
    }

    parse(value: any) {
        if (value === null || value === '') {
            return "NULL";
        }
        return this.needQuotes(value) ? `N'${value.replace("'", "''")}'` : value;
    }

    needQuotes(value: any) {
        return !this.isNumeric(value) && !this.isSqlFunction(value);
    }

    isNumeric(value: any) {
        return !isNaN(value);
    }

    isSqlFunction(value: string) {
        let funcs = ['GETDATE()', 'GETUTCDATE()', 'NEWID()', 'CURRENT_TIMESTAMP', 'CURRENT_USER', 'SESSION_USER', 'SYSTEM_USER', 'USER_NAME()', 'HOST_NAME()'];
        return funcs.includes(value.toUpperCase());
    }
}